<div
  class="alert"
  [ngClass]="{
    error: type === 'error'
  }"
>
  <ng-content></ng-content>
</div>